/* Juradem — size-chart carousel. Same motion language as the product gallery:
   mobile = coverflow drag + settle; desktop = grid with a cursor-centred loupe. */
(function(){
  const MOBILE = () => !window.matchMedia('(min-width: 990px)').matches;
  const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // constants lifted verbatim from sections/main-product.liquid
  const HERO=0.89, PEEK=30, TILT=18, ZTILT=4, DEPTH=110, SCALE=0.14, DIM=0.42, BLUR=2.0, PARALLAX=8;
  const ZOOM=3.4, PANE_W=340;

  function init(root){
    const stage = root.querySelector('.jr-cc__stage');
    const track = root.querySelector('.jr-cc__track');
    const dots  = Array.from(root.querySelectorAll('.jr-cc__dot'));
    const slides = Array.from(track.children);
    let index = 0, dragging = false, startX = 0, basePct = 0, lastX = 0, lastT = 0;
    let width = stage.clientWidth;
    const SWIPE = 0.15, FLICK = 0.5;

    function paintDepth(pos){
      if(RM) return;
      for(let i=0;i<slides.length;i++){
        const d = Math.max(-1.6, Math.min(1.6, i - pos));
        const a = Math.abs(d), c = Math.min(1, a);
        slides[i].style.transform =
          'translateX(' + (-d*PEEK).toFixed(3) + '%) ' +
          'rotateY(' + (-d*TILT).toFixed(3) + 'deg) ' +
          'rotateZ(' + (d*ZTILT).toFixed(3) + 'deg) ' +
          'translateZ(' + (-c*DEPTH).toFixed(2) + 'px) ' +
          'scale(' + (HERO*(1 - SCALE*c)).toFixed(4) + ')';
        slides[i].style.opacity = (1 - DIM*c).toFixed(4);
        slides[i].style.filter = c > 0.02 ? 'blur(' + (c*BLUR).toFixed(2) + 'px)' : 'none';
        slides[i].style.zIndex = String(100 - Math.round(a*10));
        const img = slides[i].firstElementChild;
        if(img) img.style.transform = 'translate3d(' + (d*PARALLAX).toFixed(2) + '%,0,0)';
      }
    }
    function go(i, animate){
      index = Math.max(0, Math.min(slides.length-1, i));
      track.classList.toggle('is-animating', !!animate);
      track.style.transform = 'translate3d(' + (-index*100) + '%,0,0)';
      paintDepth(index);
      dots.forEach((d,k)=> d.classList.toggle('is-active', k===index));
    }
    stage.addEventListener('pointerdown', e=>{
      if(!MOBILE()) return;
      dragging = true; track.classList.remove('is-animating');
      root.classList.add('is-dragging');
      startX = lastX = e.clientX; basePct = -index*100; lastT = performance.now();
      stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', e=>{
      if(!dragging) return;
      const pct = basePct + ((e.clientX - startX)/width)*100;
      track.style.transform = 'translate3d(' + pct + '%,0,0)';
      paintDepth(-pct/100);
      lastX = e.clientX; lastT = performance.now();
    });
    stage.addEventListener('pointerup', e=>{
      if(!dragging) return;
      dragging = false; root.classList.remove('is-dragging');
      const dx = e.clientX - startX;
      const v = Math.abs((e.clientX - lastX)/Math.max(1, performance.now()-lastT));
      let next = index;
      if(Math.abs(dx)/width > SWIPE || v > FLICK) next = dx < 0 ? index+1 : index-1;
      go(next, true);
    });
    root.querySelector('.jr-prev').addEventListener('click', ()=> go(index-1, true));
    root.querySelector('.jr-next').addEventListener('click', ()=> go(index+1, true));
    dots.forEach((d,k)=> d.addEventListener('click', ()=> go(k, true)));
    window.addEventListener('resize', ()=>{ width = stage.clientWidth; go(index, false); }, {passive:true});
    go(0, false);

    /* desktop loupe — identical behaviour to the gallery's */
    if(!MOBILE() && !RM){
      const grid = root.querySelector('.jr-cc__grid');
      const pane = document.createElement('div');
      pane.className='jr-cc__zoom'; pane.setAttribute('aria-hidden','true');
      document.body.appendChild(pane);   // Dawn's scroll-reveal transforms an ancestor of .jr-cc,
                                         // which would capture position:fixed
      const hiRes = u => u && u.indexOf('width=')>-1 ? u.replace(/width=\d+/,'width=2400') : u;
      let src=null, dims=null;
      const size = item=>{
        const r=item.getBoundingClientRect();
        const w=PANE_W, h=Math.round(w*(r.height/r.width));
        pane.style.width=w+'px'; pane.style.height=h+'px';
        pane.style.backgroundSize=(ZOOM*100)+'%';
        return {w,h};
      };
      const follow = (e,w,h)=>{
        let left=Math.max(4, Math.min(e.clientX-w/2, window.innerWidth-w-4));
        let top =Math.max(4, Math.min(e.clientY-h/2, window.innerHeight-h-4));
        pane.style.left=Math.round(left)+'px'; pane.style.top=Math.round(top)+'px';
      };
      grid.addEventListener('mouseover', e=>{
        const item=e.target.closest('.jr-cc__item'); if(!item) return;
        const img=item.querySelector('img'); if(!img) return;
        src=item; dims=size(item); follow(e,dims.w,dims.h);
        pane.style.backgroundImage='url("'+hiRes(img.currentSrc||img.src)+'")';
        root.classList.add('is-zooming'); pane.classList.add('is-on');
      });
      grid.addEventListener('mousemove', e=>{
        if(!src) return;
        const r=src.getBoundingClientRect();
        const x=Math.min(1,Math.max(0,(e.clientX-r.left)/r.width));
        const y=Math.min(1,Math.max(0,(e.clientY-r.top)/r.height));
        pane.style.backgroundPosition=(x*100).toFixed(2)+'% '+(y*100).toFixed(2)+'%';
        if(dims) follow(e,dims.w,dims.h);
      });
      grid.addEventListener('mouseleave', ()=>{ src=null; dims=null; root.classList.remove('is-zooming'); pane.classList.remove('is-on'); });
    }
  }
  const boot = ()=> document.querySelectorAll('.jr-cc').forEach(init);
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
